const playlistsSq=[
    {
    id:1,
    imgURL:"https://thisis-images.scdn.co/37i9dQZF1DZ06evO1aBeik-default.jpg",
    name:"This is Post Malone",
    info:"This is Post Malone. The essential tracks, all in one playlist."
},
{
    id:2,
    imgURL:"https://thisis-images.scdn.co/37i9dQZF1DZ06evO0QBBOU-default.jpg",
    name:"This is Pritam",
    info:"This is Pritam. The essential tracks, all in one playlist."
},
{
    id:3,
    imgURL:"https://thisis-images.scdn.co/37i9dQZF1DZ06evO0KEAbC-default.jpg",
    name:"This is A.R. Rahman",
    info:"This is A.R. Rahman. The essential tracks, all in one playlist."
},
{
    id:4,
    imgURL:"https://i.scdn.co/image/ab67706f000000025b86750761a8b78aac8a6d2a",
    name:"This is AP Dhillon",
    info:"This is A.P. Dhillon. The essential tracks, all in one playlist."
},
{
    id:5,
    imgURL:"https://thisis-images.scdn.co/37i9dQZF1DZ06evO2k3tf2-large.jpg",
    name:"This is TØP",
    info:"This is Twenty One Pilots. The essential tracks, all in one playlist."
},
{
    id:6,
    imgURL:"https://lite-images-i.scdn.co/image/ab67706f000000020b5dffb6f645059b157fc77b",
    name:"Rap Workout",
    info:"By Spotify"
},
{
    id:7,
    imgURL:"https://i.scdn.co/image/ab67706f000000028c01cd68c20590e60c130f39",
    name:"Workout Hits",
    info:"By Spotify"
},
{
    id:8,
    imgURL:"https://lite-images-i.scdn.co/image/ab67706f000000029249b35f23fb596b6f006a15",
    name:"Beast Mode",
    info:"By Spotify"
},
{
    id:9,
    imgURL:"https://i.scdn.co/image/ab67706f00000002c811b5d005a7c0d226350c46",
    name:"Workout Hip-Hop",
    info:"By Spotify"
},
{
    id:10,
    imgURL:"https://i.scdn.co/image/ab67706f000000025b9afc20f73de2953ea450f7",
    name:"Power Workout",
    info:"By Spotify"
}

];

export default playlistsSq;
